import { IonApp, setupIonicReact } from '@ionic/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense, useEffect } from 'react'

import { SuspenseFallbackMyMonitoring } from '@apps-common/components/fallback'
import { initFirebase } from '@apps-common/config/firebase'
import { PortalAuthProvider } from '@apps-common/contexts'
import { queryClient } from '@apps-common/lib/react-query'
import { AppRoutes } from '@apps-my-monitoring/routes'
import '@apps-my-monitoring/styles/custom-styles.scss'

import '@apps-my-monitoring/styles/tailwind.css'
import '@ionic/react/css/core.css'

const env = process.env.REACT_APP_ENV

setupIonicReact({
  scrollAssist: true,
  scrollPadding: true
})

const App = () => {
  initFirebase()

  useEffect(() => {
    console.log(env)
    // if (env === 'production') {
    //   console.log(`Logging is disabled in ${env} environment`)
    //   console.log = () => {}
    // } else {
    //   console.log(`Logging is enabled in ${env} environment`)
    // }
  }, [])

  return (
    <Suspense fallback={<SuspenseFallbackMyMonitoring />}>
      <QueryClientProvider client={queryClient}>
        <PortalAuthProvider>
          <IonApp>
            {/* <MyMonitoringSiteProvider> */}
            {/* <NotificationProvider pushHook={useMyMonitoringPush}> */}
            {/* <ControlProvider> */}
            <AppRoutes />
            {/* </ControlProvider> */}
            {/* </NotificationProvider> */}
            {/* </MyMonitoringSiteProvider> */}
          </IonApp>
        </PortalAuthProvider>
      </QueryClientProvider>
    </Suspense>
  )
}

export default App
